import { render, staticRenderFns } from "./termsText.vue?vue&type=template&id=67164a92&scoped=true&"
import script from "./termsText.vue?vue&type=script&lang=js&"
export * from "./termsText.vue?vue&type=script&lang=js&"
import style0 from "./termsText.vue?vue&type=style&index=0&id=67164a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67164a92",
  null
  
)

export default component.exports